export default class ClientLogos {

	/**
	 * @param {HTMLElement} element
	 */
	constructor(element) {
		const marqueeTrack = element.querySelector('.marquee-track');
		if (!marqueeTrack) {
			return;
		}
		Array.from(marqueeTrack.children).forEach(marqueeItem => {
			const clone = marqueeItem.cloneNode(true);
			clone.setAttribute('aria-hidden', 'true');
			clone.dataset.copy = 'duplicate';
			marqueeTrack.appendChild(clone);
		});
		const setMarqueeDuration = () => {
			marqueeTrack.style.setProperty('--duration', `${marqueeTrack.scrollWidth / 2 / 20}s`);
		};
		setMarqueeDuration();
		new ResizeObserver(setMarqueeDuration).observe(marqueeTrack);
	}

}
